import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();

  // Define the path mapping for breadcrumb labels
  const pathLabels = {
    '/': 'Home',
    '/about': 'About',
    '/services': 'Services',
    '/services/safety-valve': 'Safety Valve & Breather Valves',
    '/services/actuator': 'Actuator Service',
    '/services/valve-service': 'Control & Isolation Valves',
    '/services/arc-valve': 'ARC Valve Service',
    '/services/bfp-service': 'Pump Services',
    '/services/spares': 'Spares Supply',
    '/services/workshop': 'Workshop Support',
    '/careers': 'Careers',
    '/our-clients': 'Our Clients',
    '/contact': 'Contact'
  };

  // Generate breadcrumb items based on current path
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    const breadcrumbs = [];

    // Always start with Home
    breadcrumbs.push({
      label: 'Home',
      path: '/',
      isActive: location.pathname === '/'
    });

    // Build breadcrumbs from path segments
    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const isLast = index === pathSegments.length - 1;
      
      breadcrumbs.push({
        label: pathLabels[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
        path: currentPath,
        isActive: isLast
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumb on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={breadcrumb.path} className="breadcrumb-item">
            {index > 0 && (
              <ChevronRight className="breadcrumb-separator" />
            )}
            {breadcrumb.isActive ? (
              <span className="breadcrumb-current">
                {index === 0 && <Home className="breadcrumb-home-icon" />}
                {breadcrumb.label}
              </span>
            ) : (
              <Link to={breadcrumb.path} className="breadcrumb-link">
                {index === 0 && <Home className="breadcrumb-home-icon" />}
                {breadcrumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;

